import { render, staticRenderFns } from "./StaffVacations.vue?vue&type=template&id=7036610a&scoped=true&"
import script from "./StaffVacations.vue?vue&type=script&lang=js&"
export * from "./StaffVacations.vue?vue&type=script&lang=js&"
import style0 from "./StaffVacations.vue?vue&type=style&index=0&id=7036610a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036610a",
  null
  
)

export default component.exports